/**
 * Салбар бүрийн борлуулалт — `groupBy=store` хариуны `groups`.
 *
 * ⚠️ Орлого string-ээр ирнэ. `Number()` зөвхөн эрэмбэ, туузны уртад —
 *    харуулах дүн бүр string дээрээ форматлагдана (CLAUDE.md дүрэм 3).
 */

import { formatMntShort, formatQty } from '@boots/domain';
import type { SalesReport } from '../../lib/types';
import { Meter } from '../meter';

export function StoreSales({ groups, activeId, onPick }: {
  groups: SalesReport['groups'];
  /**
   * Сонгогдсон салбар — `onPick`-тэй хамт өгвөл мөр нь ДАРАГДАХУЙЦ
   * болно (захиалгын хуудас). Тайлангийн хуудсанд зөвхөн харуулна.
   */
  activeId?: string;
  onPick?: (storeId: string) => void;
}) {
  if (groups.length === 0) {
    return <p className="text-[12.5px] text-ink-3">Энэ хугацаанд борлуулалт алга</p>;
  }

  const rows = [...groups].sort((a, b) => Number(b.revenueMnt) - Number(a.revenueMnt));
  const peak = Math.max(1, ...rows.map((g) => Number(g.revenueMnt)));

  return (
    <div className="flex flex-col gap-3">
      {rows.map((g) => (
        <div
          key={g.key}
          {...(onPick
            ? {
                role: 'button',
                tabIndex: 0,
                // Дарсан салбараа дахин дарвал шүүлтүүр цуцлагдана
                onClick: () => onPick(activeId === g.key ? '' : g.key),
                onKeyDown: (e: { key: string; preventDefault: () => void }) => {
                  if (e.key !== 'Enter' && e.key !== ' ') return;
                  e.preventDefault();
                  onPick(activeId === g.key ? '' : g.key);
                },
                'aria-pressed': activeId === g.key,
              }
            : {})}
          className={`flex flex-col gap-1.5 ${
            onPick ? 'cursor-pointer rounded-card px-2 py-1.5 -mx-2 transition hover:bg-well' : ''
          } ${activeId === g.key ? 'bg-accent-100' : ''}`}
        >
          <div className="flex items-baseline gap-2.5 text-[13px]">
            {/* Кирилл нэр тайрахгүй — боож өгнө */}
            <span className="min-w-0 text-pretty">{g.label}</span>
            <span className="num ml-auto whitespace-nowrap text-[12px] text-ink-2">{formatQty(g.units)} ш</span>
            <span className="num whitespace-nowrap">{formatMntShort(g.revenueMnt)}</span>
          </div>
          <Meter
            value={(Number(g.revenueMnt) / peak) * 100}
            label={`${g.label} — ${formatMntShort(g.revenueMnt)}, ${formatQty(g.units)} ширхэг`}
          />
        </div>
      ))}
    </div>
  );
}
